<template>
    <div class="mass-control-manage">
        群防群治管理
    </div>
</template>

<script>
    export default {
        name: "mass-control-manage"
    }
</script>

<style scoped>

</style>